import React, { Component } from 'react'
import { rewriteContentfulImageUrl } from '../../utils/contentfulImage'

interface IProps {
  hit: any
}

class SimilarHit extends Component<IProps> {
  public props: IProps

  constructor(props: IProps, context?: any) {
    super(props, context)
  }

  public render() {
    const { title,
            heroImage,
            thumbnailImage,
            tags,
            author,
            primary_topic,
          } = this.props.hit

    let url: string
    if (heroImage && heroImage.file) {
      url = heroImage.file.url
    } else if (thumbnailImage && thumbnailImage.file) {
      url = thumbnailImage.file.url
    }
    if (url) {
      url = rewriteContentfulImageUrl(url, { w: 640, h: 360, fit: 'scale' })
    }

    return(
      <div className="card col-12 col-sm-6">
        <a className="card-horizontal-column__card-container fitted" href={this.getUrl()}>
          { this.getPrimaryTag(primary_topic ? [{ title: primary_topic }] : tags, true) }
          <div className="card-horizontal-column__card-image embed-responsive embed-responsive-16by9">
            { url && <img src={url} className="card-img embed-responsive-item" /> }
          </div>
          <div className="card-img-overlay card-horizontal-column__title">
            <h4>{title}</h4>
            {author && author.fullName &&
              <span className="resource-hit__author">{author.fullName}</span>}
          </div>
        </a>
      </div>
    )
  }

  private getPrimaryTag(tags: any[], pinned: boolean) {
    const className = pinned ? 'tag-primary pinned' : 'tag-secondary'

    if (tags && tags.length > 0) {
      const key = tags[0].title
      return <span className={className}>{key}</span>
    }

    return null
  }

  private getUrl() {
    const { slug } = this.props.hit

    return `/blog${slug}`
  }
}

export default SimilarHit
